import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuote } from './types';

// The full revision lineage of a quote (oldest first) — powers the version-history navigator.
export function useBillingQuoteVersions(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingQuote[]>(
    quoteId ? `commenda-billing/quotes/${quoteId}/versions` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { versions: data ?? [], error, isLoading, mutate };
}
